import React, { useState } from 'react';
import { FadeIn } from './FadeIn';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function FAQSection() {
  const faqs = [{
    q: '¿Tengo que comprar comida cara?',
    a: 'No, todo se encuentra en la verdulería y carnicería de barrio.'
  }, {
    q: '¿Es difícil de seguir?',
    a: 'Está diseñado para mujeres reales con poco tiempo; las reglas son simples y directas.'
  }, {
    q: '¿Puedo tomar mate?',
    a: 'Sí, el mate es un gran aliado si se consume sin azúcar.'
  }, {
    q: '¿Tengo que hacer ayuno?',
    a: 'Solo recomendamos un descanso digestivo nocturno de 12 horas, algo natural y saludable.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 bg-white" data-id="element-20">
      <div className="container mx-auto px-4 md:px-6 max-w-3xl" data-id="element-21">
        <FadeIn data-id="element-22">
          <div className="text-center mb-16" data-id="element-23">
            <h2 className="font-serif text-3xl md:text-4xl font-bold text-brand-charcoal mb-4" data-id="element-24">
              Preguntas Frecuentes
            </h2>
            <div className="w-24 h-1 bg-brand-orange mx-auto rounded-full" data-id="element-25"></div>
          </div>
        </FadeIn>

        <div className="space-y-4" data-id="element-26">
          {faqs.map((faq, index) => <FadeIn key={index} delay={0.1 * index} direction="up" data-id="element-27">
              <div className="border border-gray-200 rounded-2xl overflow-hidden bg-gray-50" data-id="element-28">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-29">
                  <span className="font-serif text-lg md:text-xl font-bold text-brand-charcoal pr-4" data-id="element-30">
                    {faq.q}
                  </span>
                  <ChevronDown className={`w-6 h-6 text-brand-orange flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-31" />
                </button>
                <AnimatePresence data-id="element-32">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-33">
                      <div className="px-6 pb-6 text-gray-600 leading-relaxed" data-id="element-34">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}